const STARTED = 'STARTED';
const ENDED = 'ENDED';
const ConversationStatusTypes = {
  STARTED,
  ENDED
};
export default ConversationStatusTypes;